import { ReactNode } from 'react';

import { WithClassName } from '../types';
import { InfoBusinessCardContent } from './InfoBusinessCardContent/InfoBusinessCardContent';
import { InfoBusinessCardWrapper } from './InfoBusinessCardWrapper/InfoBusinessCardWrapper';

export function InfoBusinessCard({
  icon,
  title,
  subheading,
  children,
  withSeparator,
  className,
  subheadingClassName,
}: {
  icon?: ReactNode;
  title: ReactNode;
  subheading?: ReactNode;
  children: ReactNode;
  withSeparator?: boolean;
  subheadingClassName?: string;
} & WithClassName) {
  return (
    <InfoBusinessCardWrapper withSeparator={withSeparator}>
      <InfoBusinessCardContent
        title={title}
        subheading={subheading}
        icon={icon}
        withSeparator={withSeparator}
        className={className}
        subheadingClassName={subheadingClassName}
      >
        {children}
      </InfoBusinessCardContent>
    </InfoBusinessCardWrapper>
  );
}
